export default "/static/assets/fit.ef1f35299bcca6e9fa64633349af17fb.svg";